import React from 'react';
import './StepIndicator.css';

const StepIndicator = ({ currentStep, totalSteps }) => {
  return (
    <div className="step-indicator">
      <div className="step-indicator__progress">
        <div 
          className="step-indicator__progress-bar"
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        />
      </div>
      <div className="step-indicator__text">
        Step {currentStep} of {totalSteps}
      </div>
    </div>
  );
};

export default StepIndicator; 